import r from "react";
import { N as a } from "./context-CqAjIyj3.mjs";
import { N as s } from "./Compact-8zmhZt2C.mjs";
const m = (o) => {
  const {
    space: l,
    form: n,
    children: e
  } = o;
  if (e == null)
    return null;
  let t = e;
  return n && (t = /* @__PURE__ */ r.createElement(a, {
    override: !0,
    status: !0
  }, t)), l && (t = /* @__PURE__ */ r.createElement(s, null, t)), t;
}, i = m;
export {
  i as C
};
//# sourceMappingURL=ContextIsolator-DZCr818D.mjs.map
